import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './ReadMore.styles';

export interface ReadMoreProps {
  limit?: number;
  children: string;
}

export const ReadMore = ({ children, limit = 100 }: ReadMoreProps) => {
  const limitExceeded = limit < children.length;
  const [isReadMore, setIsReadMore] = useState(limitExceeded);
  const { t } = useTranslation('common');

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const getText = () => {
    const text = children;

    if (isReadMore) {
      return `${text.slice(0, limit)}...`;
    }

    return text;
  };

  return (
    <span>
      {getText()}
      {limitExceeded && (
        <S.ReadMoreButton
          label={isReadMore ? t('common:readMore') : t('common:showLess')}
          onClick={toggleReadMore}
        />
      )}
    </span>
  );
};

ReadMore.Styled = S;
